import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "./ui/dialog";
import { useI18n } from "../i18n/I18nContext";

function fmt(v) {
  if (v == null) return "—";
  if (Array.isArray(v)) return `${v.length} item(s)`;
  if (typeof v === "object") return JSON.stringify(v);
  return String(v);
}

export default function CorrectionsDialog({ record, open, onOpenChange }) {
  const { t } = useI18n();
  const list = record?.corrections || [];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[80vh] overflow-y-auto scrollbar-thin" data-testid="corrections-dialog">
        <DialogHeader>
          <DialogTitle className="font-head text-lg">{t("correction_history")}</DialogTitle>
          <DialogDescription className="sr-only">{t("correction_history")}</DialogDescription>
        </DialogHeader>
        {list.length === 0 ? (
          <p className="text-sm text-[#627D98]">{t("no_corrections")}</p>
        ) : (
          <div className="space-y-3">
            {list.map((c, i) => (
              <div key={i} className="rounded-xl border border-[#E3EFF9] p-3 text-sm">
                <div className="text-xs text-[#627D98] mb-1.5">
                  {new Date(c.at).toLocaleString("pt-PT")} · {c.author_name}
                </div>
                {Object.keys(c.after || {}).map((k) => (
                  <div key={k} className="flex justify-between gap-2 py-0.5">
                    <span className="text-[#627D98] shrink-0">{k}</span>
                    <span className="text-[#0D253F] text-right min-w-0 break-all">
                      <span className="line-through text-[#C5221F]/70">{fmt(c.before?.[k])}</span>
                      {" → "}
                      <span className="text-[#137333] font-medium">{fmt(c.after?.[k])}</span>
                    </span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
